<template>
  <div v-if="notice" class="cart-notice" role="status" @focusin="pause" @focusout="schedule" @mouseenter="pause" @mouseleave="schedule">
    <span>Додано до кошика</span>
    <button type="button" @click="openCart">Перейти до кошика</button>
    <button type="button" class="notice-close" aria-label="Закрити повідомлення" @click="dismiss">×</button>
  </div>
</template>
<script>
export default {
  data: () => ({ timer: null }),
  computed: { notice() { return this.$store.getters.cartNotice; } },
  watch: { notice() { this.schedule(); } },
  beforeDestroy() { clearTimeout(this.timer); },
  methods: {
    pause() { clearTimeout(this.timer); },
    schedule() { this.pause(); if (this.notice) this.timer = setTimeout(this.dismiss, 4000); },
    dismiss() { this.$store.commit("hideCartNotice"); },
    openCart() { this.dismiss(); this.$emit("open-cart"); },
  },
};
</script>
<style scoped>
.cart-notice { position: fixed; left: 50%; bottom: calc(16px + env(safe-area-inset-bottom, 0px)); transform: translateX(-50%); z-index: 100; width: calc(100% - 24px); max-width: 480px; display: flex; align-items: center; gap: 8px; padding: 8px 12px; border: 1px solid #16abb8; border-radius: 10px; background: #e8f7f9; color: #075a63; box-shadow: 0 2px 10px #0002; font: 14px/20px Inter, sans-serif; }
.cart-notice button { min-height: 44px; border: 0; background: transparent; color: #075a63; font: 600 13px/18px Inter, sans-serif; cursor: pointer; }
.cart-notice .notice-close { min-width: 40px; font-size: 24px; }
</style>
